import React from 'react';
import { observer } from 'mobx-react';
import { Select } from 'antd';
import { useStores } from '@app/hooks/stores';

declare type ProfilesSelectProps = {
  onChange: (value) => void;
  selectedValue?: number | null;
  disabled?: boolean;
  placeholder: string;
};

const ProfilesSelect: React.FC<ProfilesSelectProps> = ({
  onChange,
  selectedValue,
  disabled = false,
  placeholder = ''
}) => {
  const { profilesStore } = useStores();
  const { listProfiles } = profilesStore;
  const options = listProfiles.map(prof => ({ label: prof.name, value: prof.id }));
  const onClear = () => onChange(null);
  return (
    <Select
      allowClear
      placeholder={placeholder}
      disabled={disabled}
      onChange={onChange}
      onClear={onClear}
      options={options}
      defaultValue={selectedValue}
      style={{ width: 200 }}
    />
  );
};

export default observer(ProfilesSelect);
